import React, { useState } from "react";
import api, { errText } from "@/lib/api";
import { toast } from "sonner";
import { Star } from "lucide-react";

export default function Reviews() {
  const [f, setF] = useState({ name: "", rating: 5, text: "" });
  const [sent, setSent] = useState(false);
  const submit = async () => {
    try { await api.post("/reviews", f); setSent(true); toast.success("Thanks for your feedback!"); }
    catch (e) { toast.error(errText(e.response?.data?.detail)); }
  };
  const input = "w-full h-12 px-4 rounded-sm border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#C5A059]";

  return (
    <div className="max-w-xl mx-auto px-5 py-16">
      <h1 className="font-display text-4xl font-black">Leave us feedback</h1>
      <p className="mt-3 text-slate-600">We'd love to hear about your experience with Keystone Shield Insurance.</p>
      {sent ? (
        <div className="mt-8 bg-white border border-slate-200 rounded-sm p-8 text-center" data-testid="review-success">
          <p className="font-display text-2xl font-bold">Thank you!</p>
          <p className="text-slate-600 mt-2">Your feedback helps us serve you better. If you'd like to share publicly, you can also leave us a review on Google or Facebook.</p>
        </div>
      ) : (
        <div className="mt-8 bg-white border border-slate-200 rounded-sm p-6 space-y-4">
          <input className={input} placeholder="Your Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="review-name" />
          <div className="flex gap-1">
            {[1,2,3,4,5].map((n) => (
              <button key={n} onClick={() => setF({ ...f, rating: n })} data-testid={`review-star-${n}`}>
                <Star size={28} className={n <= f.rating ? "fill-[#C5A059] text-[#C5A059]" : "text-slate-300"} />
              </button>
            ))}
          </div>
          <textarea className="w-full min-h-[120px] p-3 rounded-sm border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#C5A059]" placeholder="Tell us about your experience…" value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} data-testid="review-text" />
          <button onClick={submit} className="w-full bg-[#C5A059] text-[#0B1E36] font-bold py-4 rounded-sm hover:bg-[#0B1E36] hover:text-white transition-colors" data-testid="review-submit">SUBMIT FEEDBACK</button>
          <p className="text-xs text-slate-500">Feedback is reviewed by our team and is not published automatically.</p>
        </div>
      )}
    </div>
  );
}
